import { clientCache } from "@/utils/clientCache";
import { TranslationConfiguration } from "@/models/TranslationConfiguration";
import { AbbreviationDefaults, AbbreviationSettings, emptyAbbreviationSettings } from "@/models/AbbreviationSettings";

import { confugrationApi } from '@/api/configurationApi'

const oneDayInSeconds = 24 * 60 * 60;

export class userSettingsService {

    static clearCache() {
        this.removeUserSettingsFromCache();
    }

    async getUserTranslationConfig() {
        const userSettings = await this.getUserSettins();
        return userSettings?.pageConfig;
    }

    async getUserTourConfig() {
        const userSettings = await this.getUserSettins();
        return userSettings?.tourConfig;
    }

    async getSkipUploadNotification() {
        const userSettings = await this.getUserSettins();
        return userSettings?.uploadFileNotification;
    }

    async getHasSeenDesignUpdate() {
        const userSettings = await this.getUserSettins();
        return userSettings?.hasSeenDesignUpdate;
    }

    async getAbbreviations(): Promise<AbbreviationSettings> {
        const userSettings = await this.getUserSettins();
        const abbreviations = userSettings?.abbreviations;

        if (abbreviations == null) {
            return emptyAbbreviationSettings();
        }

        return {
            neverSplitAdded: abbreviations.neverSplitAdded ?? [],
            neverSplitSuppressed: abbreviations.neverSplitSuppressed ?? [],
            maySplitAdded: abbreviations.maySplitAdded ?? [],
            maySplitSuppressed: abbreviations.maySplitSuppressed ?? [],
        };
    }

    async getAbbreviationDefaults(): Promise<AbbreviationDefaults> {
        const defaults = await confugrationApi.getAbbreviationDefaults();

        return {
            neverSplit: defaults?.neverSplit ?? [],
            maySplit: defaults?.maySplit ?? [],
        };
    }

    async getUserSettins() {
        const userSettings = this.getUserSettingsFromCache();
        if (userSettings !== null) {
            return userSettings;
        }

        const loaddedUserSettings = await this.loadUserSettings()
        return loaddedUserSettings;
    }

    async saveTranslationConfig(config: TranslationConfiguration) {
        this.clearUserSettings();
        return confugrationApi.saveTranslationConfig(config);
    }

    async saveAbbreviations(settings: AbbreviationSettings) {
        this.clearUserSettings();
        return confugrationApi.saveAbbreviations(settings);
    }

    async markTourAsPassed() {
        this.clearUserSettings();
        return confugrationApi.markTourAsPassed();
    }

    async skipTourToday() {
        this.clearUserSettings();
        return confugrationApi.skipTourToday();
    }

    async markDesignUpdateSeen() {
        this.clearUserSettings();
        return confugrationApi.markDesignUpdateSeen();
    }

    async hideUploadFileMessage() {
        this.clearUserSettings();
        return confugrationApi.hideUploadFileMessage();
    }

    private async loadUserSettings() {
        const userSettings = await confugrationApi.getUserSettins();

        if (userSettings != null) {
            this.setUserSettingsToCache(userSettings);
        }

        return userSettings;
    }

    private clearUserSettings() {
        userSettingsService.removeUserSettingsFromCache()
    }

    private getUserSettingsFromCache() {
        return clientCache.get('userSettings');
    }

    private setUserSettingsToCache(value: any) {
        clientCache.set('userSettings', value, oneDayInSeconds);
    }

    static removeUserSettingsFromCache() {
        clientCache.remove('userSettings');
    }
}
